"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "m4.414 7.8394 1.4213-1.4213 7.0852 7.0853-1.4213 1.4212z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "18.5",
  cy: "5.5",
  r: "1.5",
  opacity: ".3"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "m15.04 12.79-8.5-8.5C6.35 4.1 6.09 4 5.83 4s-.51.1-.7.29L2.29 7.13c-.39.39-.39 1.03 0 1.42l8.5 8.5c.2.2.45.29.71.29s.51-.1.71-.29l2.83-2.83c.39-.4.39-1.04 0-1.43m-3.54 2.13L4.41 7.83l1.42-1.42 7.09 7.09zm2.8412 2.8362 1.4142-1.4142 4.2426 4.2426-1.4142 1.4142zM18.5 2C16.57 2 15 3.57 15 5.5S16.57 9 18.5 9 22 7.43 22 5.5 20.43 2 18.5 2m0 5c-.83 0-1.5-.67-1.5-1.5S17.67 4 18.5 4s1.5.67 1.5 1.5S19.33 7 18.5 7"
}, "2")], 'SportsCricketTwoTone');